export const POSTHOG_FEATURE_FLAGS = {
  enabledManageUsersAdminsNewLogic: "enable-manage-users-admins-new-logic",
  enableMandates: "enable-mandates",
  enabledPaymentsFilterBank: "enable-payments-filter-bank",
  fxPayouts: "fx-payouts",
  enableUsersCsvExport: "enable-users-csv-export",
  javaHideConnect: "java-hide-connect",
  javaPayments: "java-payments",
  enableCustomerBankList: "enable-customer-bank-list",
};
